/**
 * Общее для однострочного и многострочного поля. Здесь только то, что нужно
 * обоим, — специфика каждого лежит в его собственном types.
 */

export const FieldSizes = ['s', 'm'] as const;
export type FieldSize = (typeof FieldSizes)[number];

export const FieldStatuses = [
  'error',
  'warning',
  'success',
  'pending',
] as const;
export type FieldStatus = (typeof FieldStatuses)[number];
/** Статусы с вердиктом: у них есть свой цвет и иконка */
export type FieldVerdict = Exclude<FieldStatus, 'pending'>;
